// extracted by mini-css-extract-plugin
module.exports = {"homePageCampaign":"HomeCampaign_homePageCampaign__CFYD6","fullWidthDesktop":"HomeCampaign_fullWidthDesktop__19iyv","fullWidthMobile":"HomeCampaign_fullWidthMobile__1zNtN"};